(function () {
  var PaymentSetupMenu;

  module.exports = PaymentSetupMenu = (function () {
    function PaymentSetupMenu(createUi, account, block, integrationService, payNowDisabler, telemetry) {
      this.ui = createUi(require("./PaymentSetupMenu.html"), {
        settings: block.settings,
        payNowOnAccount: function () {
          var ref;
          return (ref = account.integrations.stripe) != null ? ref.enabled : void 0;
        },
        onPayNowChange: (function (_this) {
          return function () {
            if (_this.ui.payNowOnAccount() && block.settings.payNow.enabled) {
              return telemetry.trackOnly(
                "Payment Enabled",
                {},
                {
                  blockIntercom: true,
                },
              );
            }
          };
        })(this),
        setup: function () {
          return integrationService.openIntegrationSettings("stripe");
        },
        isPayNowDisabled: function () {
          return !payNowDisabler.isPayNowPossible();
        },
      });
    }

    return PaymentSetupMenu;
  })();
}.call(this));
